<template>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb" itemscope itemtype="https://schema.org/BreadcrumbList">
      <li 
        v-for="(crumb, index) in breadcrumbs" 
        :key="crumb.path" 
        class="breadcrumb-item" 
        itemprop="itemListElement" 
        itemscope 
        itemtype="https://schema.org/ListItem"
      >
        <span v-if="index === breadcrumbs.length - 1">{{ crumb.name }}</span>
        <router-link v-else :to="crumb.path" itemprop="item">
          <span itemprop="name">{{ crumb.name }}</span>
        </router-link>
        <meta itemprop="position" :content="index + 1" />
      </li>
    </ol>
  </nav>
</template>

<script>
import servicesData from "@/data/services.json";

export default {
  name: "BreadCrumbsTemplate",
  computed: {
    locale() {
      return this.$route.params.locale;
    },
    category() {
      return this.$route.params.category;
    },
    target() {
      return this.$route.params.target;
    },
    currentService() {
      return servicesData.find(service => 
        service.url[this.locale] === this.target && 
        service.category[this.locale] === this.category
      ) || null;
    },
    serviceTitle() {
      return this.currentService ? this.currentService.title[this.locale] : null;
    },
    breadcrumbs() {
      const { locale, category, target } = this.$route.params;
      const crumbs = [{ name: this.$t("breadcrumbs.home"), path: `/${locale}` }];
      let fullPath = `/${locale}`;

      const routeMap = {
        about: "about",
        contacts: "contacts",
        vacancies: "vacancies",
        services: "services"
      };


      if (this.$route.name in routeMap) {
        fullPath += `/${routeMap[this.$route.name]}`;
        crumbs.push({ name: this.$t(`breadcrumbs.${this.$route.name}`), path: fullPath });
      }


      if (this.$route.name === "serviceDetails" && category && target) {
        crumbs.push({ name: this.$t(`breadcrumbs.services`), path: `/${locale}/services` });
        if (this.serviceTitle) {
          crumbs.push({ name: this.serviceTitle, path: `/${locale}/${category}/${target}` });
        } else {
          console.warn(`[Breadcrumbs] Title для услуги '${target}' не найден!`);
        }
      }

      return crumbs;
    }
  }
};
</script>
